import React from 'react';

export default function Footer() {
  return (
    <section className="col-wrap">
      <div className="source">
        Source:{' '}
        <a href="https://www.zerotracker.net/" target="_blank" rel="noreferrer">
          Net Zero Tracker.
        </a>{' '}
        Energy and Climate Intelligence Unit, Data-Driven EnviroLab, NewClimate
        Institute, Oxford Net Zero. 2022. Some small countries not to scale on
        graphic.
      </div>
      <div className="clearme" />
    </section>
  );
}
